import { apiCall } from "../../../../services/api-service";

export const getCommonTableListApi = (id, moduleName, params) =>
  apiCall("get", `${moduleName}/${id}?${params}`);

export const getSpecificationEditApi = (url) =>
  apiCall("get", `${url}`);

export const submitSpecificationAPI = (body) =>
  apiCall("post", "specification", body);

export const getFinancialEditApi = (url) =>
  apiCall("get", `${url}`);

export const submitFinancialAPI = (body) =>
  apiCall("post", "financial", body);

export const submitFinancialDetailsAPI = (id, body) =>
  apiCall("put", `details/${id}`, body);
